module.exports = __webpack_public_path__ + "img/Group300.bf884ca5.png";